import React from 'react';
import PropTypes from 'prop-types';

import './CardsBanner.scss';

const CardsBanner = props => (
  <div className="cards-banner">{props.children}</div>
);

CardsBanner.propTypes = {
  children: PropTypes.object,
};

export default CardsBanner;



// WEBPACK FOOTER //
// ./src/components/Main/home/CardsBanner.js